import styled, { css } from 'styled-components';

const PIXELS_PER_EM = 16;

export const screenSizes = {
  phoneOnly: 599,
  tabletPortraitUp: 600,
  tabletLandscapeUp: 900,
  desktopUp: 1200,
  bigDesktopUp: 1800,
};

export const headerHeightWide = 101;
export const headerHeightNarrow = 93;

/*
  by using ${media.phoneOnly`background: dodgerblue;`} inside a styled-component
  we can make the component have a dodgerblue background for devices that have
  the screen width of a mobile phone
*/
export const media = Object.keys(screenSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (${label === 'phoneOnly' ? 'max-width' : 'min-width'}: ${screenSizes[label] / PIXELS_PER_EM}em) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

export const containerCss = css`
  display: block;
  margin: 0 auto;
  width: 100%;

  ${media.tabletPortraitUp`
    width: ${screenSizes.tabletPortraitUp}px;
  `}

  ${media.tabletLandscapeUp`
    width: ${screenSizes.tabletLandscapeUp}px;
  `}

  ${media.desktopUp`
    width: ${screenSizes.desktopUp}px;
  `}

  ${media.bigDesktopUp`
    width: ${screenSizes.bigDesktopUp}px;
  `}
`;

export const Container = styled.div`
  ${containerCss};
`;
export const StyledContainer = styled.div`
  background-color: #fafafa;
  ${media.tabletPortraitUp`
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
  `};
  ${containerCss};
`;
